import { defineStore } from 'pinia';
import { ref } from 'vue';

/**
 * Quick-add overlay state (E14).
 *
 * Single source of truth for "is the overlay open, and if so, on which form."
 * Keeps the overlay a sibling of the routed view so it doesn't tear down on
 * navigation, and so any component anywhere can open it by calling
 * `useQuickAddStore().openPicker()` or `.openFor('indicator')`.
 */

export type QuickAddType = 'note' | 'indicator' | 'actor' | 'campaign' | 'rule';

export const useQuickAddStore = defineStore('quickAdd', () => {
  // `true` when the overlay is rendered. `false` means fully unmounted —
  // picker and form state reset to defaults.
  const open = ref(false);

  // Null = show the type picker. Set to a type = jump straight into that form.
  const selectedType = ref<QuickAddType | null>(null);

  function openPicker() {
    selectedType.value = null;
    open.value = true;
  }

  function openFor(type: QuickAddType) {
    selectedType.value = type;
    open.value = true;
  }

  function close() {
    open.value = false;
    selectedType.value = null;
  }

  return { open, selectedType, openPicker, openFor, close };
});
